module.exports = __webpack_public_path__ + "static/media/search.789302e9.svg";